module.exports = __webpack_public_path__ + "img/no-data.34337ba9.png";